export const APIActionType = {
  RESET_API_DATA: "RESET_API_DATA",
  SET_TOTAL_STAKED: "SET_TOTAL_STAKED",
  SET_ALL_NFTS: "SET_ALL_NFTS",
  SET_LENT_NFTS: "SET_LENT_NFTS",
  SET_RENTED_NFTS: "SET_RENTED_NFTS",
  SET_MARKET_NFTS: "SET_MARKET_NFTS",
  SET_BORROWED_NFTS: "SET_BORROWED_NFTS",
  SET_PROFILE_NFTS: "SET_PROFILE_NFTS",
  SET_SCHOLAR_LIST_NFTS: "SET_SCHOLAR_LIST_NFTS",
  SET_USER_BALANCE: "SET_USER_BALANCE",
  SET_ALL_USER: "SET_ALL_USER",
  SET_CONNECTED_ACCOUNT: "SET_CONNECTED_ACCOUNT",
  SET_SCHOLARS: "SET_SCHOLARS",
  SET_CLAIMABLE_NFTS: "SET_CLAIMABLE_NFTS",
  SET_CW_PROFILE_NFTS: "SET_CW_PROFILE_NFTS",
  SET_CW_BORROWED_NFTS: "SET_CW_BORROWED_NFTS",
  SET_HOLDINGS: "SET_HOLDINGS",
};
